import { render, staticRenderFns } from "./Input-fields2.vue?vue&type=template&id=563e5258"
import script from "./Input-fields2.vue?vue&type=script&lang=js"
export * from "./Input-fields2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563e5258')) {
      api.createRecord('563e5258', component.options)
    } else {
      api.reload('563e5258', component.options)
    }
    module.hot.accept("./Input-fields2.vue?vue&type=template&id=563e5258", function () {
      api.rerender('563e5258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/Input-fields2.vue"
export default component.exports